import React from "react";

const ProductGallery = ({ gallery, selectedColour, activeImage, setActiveImage }) => (
  <div className="lg:col-span-7 grid grid-cols-12 gap-3">
    <div className="hidden md:flex md:col-span-2 flex-col gap-3">
      {gallery.map((src, idx) => (
        <button
          key={src}
          type="button"
          onClick={() => setActiveImage(idx)}
          className={`aspect-square border ${
            idx === activeImage ? "border-ink" : "border-line"
          } overflow-hidden`}
          data-testid={`gallery-thumb-${idx}`}
        >
          <img src={src} alt="thumbnail" className="w-full h-full object-cover" />
        </button>
      ))}
    </div>
    <div className="col-span-12 md:col-span-10">
      <div
        className="aspect-square border border-line overflow-hidden relative bg-white"
        style={
          !selectedColour.image && activeImage === 0
            ? { backgroundColor: selectedColour.hex }
            : undefined
        }
      >
        {activeImage === 0 && !selectedColour.image ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <p
                className={`wordmark uppercase tracking-wider text-5xl md:text-7xl ${
                  selectedColour.slug === "blackout-white" ? "text-white" : "text-ink"
                }`}
              >
                Pritch
              </p>
              <p
                className={`mono text-xs tracking-widest mt-2 ${
                  selectedColour.slug === "blackout-white" ? "text-white/70" : "text-ink/60"
                }`}
              >
                Grip Sock · {selectedColour.name}
              </p>
            </div>
          </div>
        ) : (
          <img
            src={gallery[activeImage]}
            alt={`Pritch grip sock · ${selectedColour.name}`}
            className="w-full h-full object-contain"
            data-testid="product-main-image"
          />
        )}
      </div>
      <div className="md:hidden grid grid-cols-4 gap-2 mt-3">
        {gallery.map((src, idx) => (
          <button
            key={`m-${src}`}
            type="button"
            onClick={() => setActiveImage(idx)}
            className={`aspect-square border ${idx === activeImage ? "border-ink" : "border-line"}`}
          >
            <img src={src} alt="thumb" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default ProductGallery;
